import React, { useState } from 'react';
import { Button, Modal, Form, Input, message, Space, Select } from 'antd';
import { FaPlus } from 'react-icons/fa6';
import { COMPANY_CATEGORIES } from '../../../../utils/companyCategories';

const { Option } = Select;

const AddNewClientComponent = () => {
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const [open, setOpen] = useState(false);
    const [form] = Form.useForm();

    //Following is for FORM display purpose only 
    const [newParty, setNewParty] = useState(false);
    const [newBrand, setNewBrand] = useState(false);

    const onFinish = async (values) => {
        try {
            const response = await fetch(`${apiBaseUrl}/inventoryManagement/addNewPartyCompanyWithBrand`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
                body: JSON.stringify(values),
            });

            const result = await response.json();

            if (result.success) {
                message.success(result.message);
                form.resetFields();
            } else {
                message.error(result.message);
            }
        } catch (error) {
            message.error('An error occurred: ' + error.message);
        }
    };

    const handleCancel = () => {
        setOpen(false);
        setNewBrand(false);
        setNewParty(false);
    };

    return (
        <>
            <Button type="primary" icon={<FaPlus />} onClick={() => setOpen(true)}>
                Add New Client
            </Button>
            <Modal open={open} onOk={() => setOpen(false)} onCancel={handleCancel} footer={null} title="Add new Client">
                {
                    !newBrand && !newParty &&
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "1rem" }}>
                        <Button onClick={() => {
                            setNewBrand(true);
                            setNewParty(false);
                        }}>
                            Add New Brand To existing Party Company
                        </Button>
                        OR
                        <Button onClick={() => {
                            setNewBrand(false);
                            setNewParty(true);
                        }}>
                            Add New Party Company Name with Brand
                        </Button>
                    </div>
                }

                {
                    newParty &&
                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={onFinish}
                        initialValues={{
                            gstNumber: '',
                            partyCompanyName: '',
                            brandName: '',
                            clientCategory: '',
                            address: "",
                            brandCategory: '',
                            brandSegment: '',
                            pCode: "",
                            // billingPartyName: '',
                            // contactPerson: '',
                            // contactNumber: '',
                            // emailId: '',
                        }}
                    >

                        <Form.Item
                            name="partyCompanyName"
                            label="Party Company Name"
                            rules={[{ required: true, message: 'Please input the parent company name!' }]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            name="address"
                            label="Company Address"
                            rules={[{ required: true, message: 'Please input the address!' }]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            name="clientCategory"
                            label="Client Category"
                            rules={[{ required: true, message: 'Please select the client category!' }]}
                        >
                            <Select placeholder="Select client category">
                                {COMPANY_CATEGORIES.map((category) => (
                                    <Option key={category} value={category}>
                                        {category}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <Form.Item
                            name="brandName"
                            label="Brand Name"
                            rules={[{ required: true, message: 'Please input the brand name!' }]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            name="gstNumber"
                            label="GST NUMBER"
                            rules={[{ required: true, message: 'Please input the GST number of the company' }]}
                        >
                            <Input />
                        </Form.Item>

                        {/* <Form.Item
                            name="billingPartyName"
                            label="Billing Party Name"
                            rules={[{ required: true, message: 'Please input the billing party name!' }]}
                        >
                            <Input />
                        </Form.Item> */}

                        <Form.Item
                            name="brandCategory"
                            label="Brand Category"
                            rules={[{ required: true, message: 'Please select the brand category!' }]}
                        >
                            <Select placeholder="Select a brand category">
                                {['Govt', 'PSU', 'Corporate', 'Retail'].map((category) => (
                                    <Option key={category} value={category}>
                                        {category}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>

                        <Form.Item
                            name="brandSegment"
                            label="Brand Segment"
                            rules={[{ required: true, message: 'Please select the brand segment!' }]}
                        >
                            <Select placeholder="Select a brand segment">
                                {[
                                    'Govt Sector',
                                    'Infrastructure',
                                    'Lifestyle',
                                    'Liquor',
                                    'Media & Entertainment',
                                    'Telecom',
                                    'Travel & Tourism',
                                ].map((segment) => (
                                    <Option key={segment} value={segment}>
                                        {segment}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <Form.Item
                            name="pCode"
                            label="P-Code"
                        >
                            <Input />
                        </Form.Item>

                        {/* <Form.Item
                            name="contactPerson"
                            label="Contact Person"
                            rules={[{ required: true, message: 'Please input the contact person!' }]}
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item
                            name="contactNumber"
                            label="Contact Number"
                            rules={[{ required: true, message: 'Please input the contact number!' }]}
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item
                            name="emailId"
                            label="Email ID"
                            rules={[{ required: true, message: 'Please input the email ID!' }]}
                        >
                            <Input />
                        </Form.Item> */}

                        <Form.Item>
                            <Button type="primary" htmlType="submit">
                                Submit
                            </Button>
                        </Form.Item>
                    </Form>
                }

                {newBrand &&
                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={onFinish}
                        initialValues={{
                            gstNumber: '',
                            partyCompanyId: '',
                            brandName: '',
                            brandCategory: '',
                            brandSegment: '',
                            // billingPartyName: '',
                            // contactPerson: '',
                            // contactNumber: '',
                            // emailId: '',
                        }}
                    >

                        <Form.Item
                            name="partyCompanyName"
                            label="Party Company Name"
                            rules={[{ required: true, message: 'Please input the parent company name!' }]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            name="address"
                            label="Company Address"
                            rules={[{ required: true, message: 'Please input the address!' }]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            name="clientCategory"
                            label="Client Category"
                            rules={[{ required: true, message: 'Please select the client category!' }]}
                        >
                            <Select placeholder="Select client category">
                                {COMPANY_CATEGORIES.map((category) => (
                                    <Option key={category} value={category}>
                                        {category}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <Form.Item
                            name="brandName"
                            label="Brand Name"
                            rules={[{ required: true, message: 'Please input the brand name!' }]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            name="gstNumber"
                            label="GST NUMBER"
                            rules={[{ required: true, message: 'Please input the GST number of the company' }]}
                        >
                            <Input />
                        </Form.Item>

                        {/* <Form.Item
                        name="billingPartyName"
                        label="Billing Party Name"
                        rules={[{ required: true, message: 'Please input the billing party name!' }]}
                    >
                        <Input />
                    </Form.Item> */}

                        <Form.Item
                            name="brandCategory"
                            label="Brand Category"
                            rules={[{ required: true, message: 'Please select the brand category!' }]}
                        >
                            <Select placeholder="Select a brand category">
                                {['Govt', 'PSU', 'Corporate', 'Retail'].map((category) => (
                                    <Option key={category} value={category}>
                                        {category}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>

                        <Form.Item
                            name="brandSegment"
                            label="Brand Segment"
                            rules={[{ required: true, message: 'Please select the brand segment!' }]}
                        >
                            <Select placeholder="Select a brand segment">
                                {[
                                    'Govt Sector',
                                    'Infrastructure',
                                    'Lifestyle',
                                    'Liquor',
                                    'Media & Entertainment',
                                    'Telecom',
                                    'Travel & Tourism',
                                ].map((segment) => (
                                    <Option key={segment} value={segment}>
                                        {segment}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <Form.Item
                            name="pCode"
                            label="P-Code"
                        >
                            <Input />
                        </Form.Item>

                        {/* <Form.Item
                        name="contactPerson"
                        label="Contact Person"
                        rules={[{ required: true, message: 'Please input the contact person!' }]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        name="contactNumber"
                        label="Contact Number"
                        rules={[{ required: true, message: 'Please input the contact number!' }]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        name="emailId"
                        label="Email ID"
                        rules={[{ required: true, message: 'Please input the email ID!' }]}
                    >
                        <Input />
                    </Form.Item> */}

                        <Form.Item>
                            <Button type="primary" htmlType="submit">
                                Submit
                            </Button>
                        </Form.Item>
                    </Form>
                }
            </Modal>
        </>
    );
};

export default AddNewClientComponent;
